import React from "react";
import AdminLayout from "../../components/layouts/AdminLayout";

function Dashboard() {
  return (
    <div>
      <AdminLayout>
        <h3>Dashboard</h3>
        <hr></hr>
      </AdminLayout>
    </div>
  );
}

export default Dashboard;
